import { useMemo } from 'react';

import { getCurrentUserPermissions, UserPermissions } from 'store';

import { useAppSelector } from './use-app-selector';

let userPermission: UserPermissions;

export const usePermissions = () => {
  const permissionsNumber = useAppSelector(getCurrentUserPermissions);

  return useMemo(() => {
    if (userPermission?.permissionsNumber === permissionsNumber) {
      return userPermission;
    }

    userPermission = new UserPermissions(permissionsNumber);

    return userPermission;
  }, [permissionsNumber]);
};
